<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="400px"
      :title="$l('form_label_salesman_adjustment') || '业务人员调整'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <Main
        ref="main"
        :fabricCodeList="fabricCodeList"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    fabricCodeList: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
